<style lang="scss" scoped>
  @import '../../styles/vars/main';
  @import '../../styles/helpers/main';
  .edit {
    display: flex;
    flex-direction: column;
    height: 100%;
    &__form {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    &__headline {
      margin-bottom: space('comfortable');
    }
    &__title {
      margin-bottom: space('comfortable');
    }
    &__description {
      height: 100%;
      margin-bottom: space('comfortable');
    }
    &__footer {
      display: flex;
      justify-content: space-between;
      flex-shrink: 0;
    }
  }
</style>
<template>
  <div class="edit">
    <form class="edit__form form">
      <v-headline :level="'2'" cssClass="--nile edit__headline">Create new {{this.singular(content)}}</v-headline>
      <p class="edit__title">
        <input type="text" v-model="title" class="textfield --headline" name="foldername" v-validate="{ required: true, unique:names }" autocomplete="off">
        <span v-show="errors.has('foldername')" class="error form__error">{{ errors.first('foldername') }}</span>
      </p>
      <textarea class="textarea edit__description" name="" id="" cols="30" rows="10" v-model="description">
        </textarea>
      <div class="edit__footer">
        <v-button cssClass="button --secondary" @click.prevent="cancel">Cancel</v-button>
        <v-button @click.prevent="save">Save new {{this.singular(content)}}</v-button>
      </div>
    </form>
  </div>
</template>
<script>
import Headline from '../headline';
import Button from '../button';
import { mapGetters, mapActions } from 'vuex';
import pluralSingular from '../../mixins/pluralSingular.js';

export default {
  components: {
    'v-headline': Headline,
    'v-button': Button
  },
  data() {
    return {
      title: '',
      description: ''
    };
  },
  props: {

  },
  mounted() { },
  computed: {
    ...mapGetters([
      'view',
      'content',
      'activeId',
      'overlay_isOpen'
    ]),
    names() {
      const data = this.$store.getters[this.content];
      // check if data is already loaded -> computed property is reactive and invoks again if data is set
      if (data) {
        return data.map((item) => {
          return item.name;
        });
      }
    }
  },
  mixins: [
    pluralSingular
  ],
  watch: {
    overlay_isOpen() {
      this.resetForm();
    }
  },
  methods: {
    cancel() {
      this.$store.commit('overlay_isOpen', false);
    },
    resetForm() {
      this.$nextTick(() => {
        this.description = null;
        this.title = null;
        this.$validator.reset();
      });
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const title = this.title;
          const description = this.description;
          const content = this.singular(this.content);
          const apiPath = this.activeId ? `${content}/${this.activeId}` : content;
          this.$store.dispatch('createFolder', { apiPath, title, description }).then(() => {
            this.cancel();
          });
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/album/create.vue